import * as yup from "yup";

export const ownerThresholdSchema = yup.object({
  ownerThresholdQuestion: yup
    .mixed<"" | "yes" | "no">()
    .oneOf(["yes", "no"])
    .required("Please select a value"),
});
